<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0">Photos</h5>
      </div>
    </div>
    <div class="trezo-card-content">
      <div class="grid grid-cols-3 gap-[10px]">
        <a href="#" class="block rounded-md">
          <img
            src="@/assets/images/products/product6.jpg"
            alt="photo-image"
            class="rounded-md"
          />
        </a>
        <a href="#" class="block rounded-md">
          <img
            src="@/assets/images/products/product7.jpg"
            alt="photo-image"
            class="rounded-md"
          />
        </a>
        <a href="#" class="block rounded-md">
          <img
            src="@/assets/images/products/product8.jpg"
            alt="photo-image"
            class="rounded-md"
          />
        </a>
        <a href="#" class="block rounded-md">
          <img
            src="@/assets/images/products/product9.jpg"
            alt="photo-image"
            class="rounded-md"
          />
        </a>
        <a href="#" class="block rounded-md">
          <img
            src="@/assets/images/products/product10.jpg"
            alt="photo-image"
            class="rounded-md"
          />
        </a>
        <a href="#" class="block rounded-md">
          <img
            src="@/assets/images/products/product11.jpg"
            alt="photo-image"
            class="rounded-md"
          />
        </a>
        <a href="#" class="block rounded-md">
          <img
            src="@/assets/images/products/product12.jpg"
            alt="photo-image"
            class="rounded-md"
          />
        </a>
        <a href="#" class="block rounded-md">
          <img
            src="@/assets/images/products/product13.jpg"
            alt="photo-image"
            class="rounded-md"
          />
        </a>
        <a href="#" class="block rounded-md">
          <img
            src="@/assets/images/products/product14.jpg"
            alt="photo-image"
            class="rounded-md"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Photos",
};
</script>
